import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatPercent } from './dashboardUtils';

interface MoMCellProps {
    value: number | null;
    // when true, negative values are shown as positive (green) and vice versa.
    invertPolarity?: boolean;
    className?: string;
}

export default function MoMCell({
    value,
    invertPolarity = false,
    className,
}: MoMCellProps) {
    if (value === null || Number.isNaN(value))
        return <span className="text-muted-foreground">—</span>;

    const isPositive = invertPolarity ? value < 0 : value >= 0;
    const Icon = isPositive ? TrendingUp : TrendingDown;
    const colorClass = isPositive ? 'text-emerald-500' : 'text-red-400';

    return (
        <span
            className={`flex items-center gap-1 text-sm ${colorClass} ${className ?? ''}`}
        >
            <Icon className="h-3.5 w-3.5" />
            {formatPercent(value)}
        </span>
    );
}
